<button class="cart-button" (click)="inCheckoutPage() ? navigateToCart() : cartOP.toggle($event)">
  <i class="pi pi-shopping-cart"></i>
  <div class="total-quantity" *ngIf="cartTotalQuantity$()">{{cartTotalQuantity$()}}</div>
</button>
<p-overlayPanel #cartOP>
  <div class="cart-panel" *ngIf="cart$()">
    <div class="head">
      {{cartTotalQuantity$()}} {{'navbar.cart.title' | translate}}
    </div>
    <div class="body">
      <div class="cart-item" *ngFor="let item of cartItems$(); let i = index;">
        <div class="data">
          <img [src]="item.icon" class="img-fluid" [alt]="item.name" />
          <div class="name">
            {{item.name}}
            <small class="quantity">{{'navbar.cart.quantity' | translate}} : {{item.quantity}}</small>
            <strong class="price">{{item.price | currency : item.currency}}</strong>
          </div>
        </div>
        <div class="action" *ngIf="!checkoutPageIsOpen()">
          <i class="pi pi-trash" (click)="removeItem(item, i)"></i>
        </div>
      </div>
      <div class="cart-is-empty text-center" *ngIf="!cartItems$().length">{{'navbar.cart.emptyCart' | translate}}</div>
    </div>
    <div class="foot">
      <div class="total-price" *ngIf="cartTotal$();">
        <div class="label">{{'navbar.cart.total' | translate}} : </div>
        <div class="price">{{currencyCalculator.convertCurrency(cartTotalPrice$() , cart$().currency, currency$(),
          exchanges) }} {{ currency$() }} </div>
      </div>
      <button class="view-cart" (click)="navigate(language$() + '/settings/cart')">{{'navbar.cart.viewCart' |
        translate}}</button>
      <button class="checkout" (click)="navigate(language$() + '/checkout')">{{'navbar.cart.checkout' |
        translate}}</button>
    </div>
  </div>
</p-overlayPanel>